(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["si-special-requests"] && !Shopify.designMode) return;
  try {
    
  function initSpecialRequestForm(){const form=document.querySelector('#SpecialRequestForm');if(!form)return;const params=new URLSearchParams(window.location.search);const field=form.querySelector('#sr-design');const design=params.get('design');const handle=params.get('product');if(field&&!field.value&&(design||handle)){field.value=design||handle;if(handle&&/^[a-z0-9-]+$/.test(handle))field.value+='\n'+window.location.origin+'/products/'+handle;}const date=form.querySelector('#sr-date');if(date){const now=new Date();const day=[now.getFullYear(),String(now.getMonth()+1).padStart(2,'0'),String(now.getDate()).padStart(2,'0')].join('-');date.min=day;}const success=form.querySelector('.si-special-success');if(success)success.focus();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initSpecialRequestForm);}else{initSpecialRequestForm();}document.addEventListener('shopify:section:load',initSpecialRequestForm);

  } catch(e) { console.error(e); }
})();
})();
